<template>
  <v-container class="profile-page" style="min-height: 100vh">
    <v-form v-model="valid" ref="form">
      <v-row justify="center">
        <v-col cols="12" md="12" sm="12">
          <h2 class="mt-1">
            <span class="grey--text">{{ $t("setting.title") }}</span>

            {{ userMe.b_name }}
          </h2>
          <!-- <v-btn
            fixed
            color="primary"
            class="white--text ma-3"
            @click="updateCompany()"
            fab
            left
            bottom
          >
            <v-icon>mdi-update</v-icon>
          </v-btn> -->
        </v-col>
      </v-row>
      <v-row justify="center" class="mb-3">
        <v-col cols="12" md="8" class="mb-0">
          <v-card elevation="0">
            <!-- <v-toolbar dark color="primary">
            <v-btn icon dark @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Settings</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark text @click="dialog = false"> Save </v-btn>
            </v-toolbar-items>
          </v-toolbar> -->

            <v-img :src="avatar ? avatar : userMe.avatar" height="350px" dark>
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
            <v-card-text class="pt-6" style="position: relative">
              <v-btn
                absolute
                color="primary"
                class="white--text"
                fab
                @click="avatarPicker()"
                right
                top
              >
                <v-icon>mdi-camera</v-icon>
              </v-btn>

              <v-file-input
                v-model="newAvatar"
                id="avatarPicker"
                ref="avatar"
                @change="selectFile"
                accept="image/png, image/jpeg, image/bmp"
                color="primary"
                style="display: none"
              ></v-file-input>
            </v-card-text>

            <v-list two-line>
              <v-subheader> {{ $t("setting.accountInfo") }}</v-subheader>
              <v-list-item>
                <v-list-item-content>
                  <v-text-field
                    :label="$t('input.name')"
                    prepend-icon="mdi-account"
                    outlined
                    :rules="[rules.required && rules.name]"
                    v-model="userMe.name"
                  ></v-text-field>
                  
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-text-field
                    :label="$t('input.companyName')"
                    prepend-icon="mdi-domain"
                    outlined
                    disabled
                    :rules="[rules.required && rules.name]"
                    v-model="userMe.b_name"
                  ></v-text-field>
                  
                </v-list-item-content>
              </v-list-item>
              <languages />
              <v-list-item>
                <v-list-item-content>
                  <v-text-field
                    label="Account type"
                    outlined
                    prepend-icon="mdi-view-module"
                    v-model="userMe.position"
                    disabled
                  ></v-text-field>
                </v-list-item-content>
              </v-list-item>
              <!-- 
              <v-list-item>
                <v-list-item-content>
                  <v-switch
                    prepend-icon="mdi-call-split"
                    v-model="userMe.at_wrok"
                    label="خارج الخدمة لن يتم توجيه الطلبات بشكل آلي للشركة "
                  ></v-switch>
                </v-list-item-content>
              </v-list-item> -->

              <v-divider></v-divider>
              <v-subheader>{{ $t("setting.connect") }}</v-subheader>

              <v-list-item>
                <v-list-item-content>
                  <v-text-field
                    :label="$t('input.email')"
                    :rules="[rules.required, rules.emailMatch]"
                    outlined
                    prepend-icon="mdi-email"
                    v-model="userMe.email"
                  ></v-text-field>
                </v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-list-item-content>
                  <v-text-field
                    :label="$t('input.number')"
                    disabled
                    :rules="[rules.required]"
                    :suffix="userMe.code"
                    outlined
                    prepend-icon=" mdi-phone"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                    v-model="userMe.number"
                  ></v-text-field>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-subheader>{{ $t("setting.address") }}</v-subheader>

              <v-list-item>
                <v-list-item-content>
                  <v-text-field
                    :label="$t('input.address')"
                    :rules="[rules.required, rules.min]"
                    outlined
                    prepend-icon=" mdi-map-marker"
                    v-model="userMe.address"
                  ></v-text-field>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-text-field
                    :label="$t('input.country')"
                    outlined
                    disabled
                    prepend-icon="mdi-call-split"
                    v-model="userMe.country"
                  ></v-text-field>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-text-field
                    :label="$t('input.city')"
                    outlined
                    disabled
                    prepend-icon="mdi-call-split"
                    :value="getCity(userMe.city)"
                  ></v-text-field>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>
        <!---work time -->
        <v-col md="8" cols="12" class="  ">
          <v-card width="100%" elevation="0">
            <v-subheader
              >Wizard Api developers - (need Businesses plan)</v-subheader
            >

            <v-list two-line>
              <v-list-item to="/app/developer">
                <v-list-item-content>
                  <v-list-item-title>
                    <v-icon> mdi-brightness-5 </v-icon> Go to your
                    app</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                target="blank"
                href="https://docs.google.com/forms/d/e/1FAIpQLSfhb-Cs-sOgS_KcCmrhxdRLN7sL2DYC6CgCzIB1IYBZj1pdIw/viewform"
              >
                <v-list-item-content>
                  <v-list-item-title>
                    <v-icon> mdi-plus </v-icon> Request new app
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <!-- <v-list-item>
                <v-list-item-content>
                  <v-text-field
                    :label="$t('input.visa')"
                    outlined
                    disabled
                    prepend-icon="mdi-domain"
                  ></v-text-field>
                </v-list-item-content>
              </v-list-item> -->
              <!-- <v-list-item>
                <v-list-item-content>
                  <v-text-field
                    label="أسم الشركة"
                    prepend-icon="mdi-domain"
                    outlined
                    :rules="[rules.required && rules.name]"
                    v-model="userMe.name"
                  ></v-text-field>
                </v-list-item-content>
              </v-list-item> -->
            </v-list>
          </v-card></v-col
        >
        <v-col md="8" cols="12" class=" ">
          <v-card width="100%" elevation="0">
            <v-row justify="center" class="px-4 pt-4">
              <v-col cols="12" sm="12" class="ma-0 pa-0">
                <v-checkbox
                  v-model="changePass"
                  class="ma-1 pa-1"
                  :label="$t('setting.changePassword')"
                ></v-checkbox>
              </v-col>
              <v-col cols="12" sm="6" v-if="changePass">
                <v-text-field
                  prepend-icon="mdi-eye"
                  :label="$t('input.passowrd')"
                  v-model="userMe.password"
                  :rules="[rules.required, rules.min]"
                  outlined
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6" v-if="changePass">
                <v-text-field
                  :rules="[rules.required, rules.confirmPasswordRules]"
                  outlined
                  prepend-icon="mdi-eye"
                  :label="$t('input.confirmPassword')"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6" v-if="!changePass">
                <v-text-field
                  prepend-icon="mdi-eye"
                  :label="$t('input.passowrd')"
                  v-model="userMe.password"
                  outlined
                  disabled
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6" v-if="!changePass">
                <v-text-field
                  outlined
                  disabled
                  prepend-icon="mdi-eye"
                  :label="$t('input.confirmPassword')"
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-card>
        </v-col>

        <!---save changes -->
        <v-col md="8" cols="12" class="mt-3">
          <v-card width="100%" elevation="0">
            <v-row justify="center" class="px-4 pt-4">
              <v-col cols="6">
                <v-btn
                  block
                  :loading="loading"
                  :disabled="loading"
                  color="primary"
                  @click="updateCompany()"
                >
                  {{ $t("btn.save") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card></v-col
        >
      </v-row>
    </v-form>
  </v-container>
</template>
<script>
import languages from "../../core/languages.vue";
import { mapActions, mapState, mapGetters } from "vuex";
export default {
  name: "setting-page",
  data(v) {
    return {
      clicked: false,
      param: null,
      changePass: false,
      avatar: null,
      newAvatar: null,
      valid: true,
      data: {},
      loading: false,
      rules: {
        confirmPasswordRules: null,
        required: null,
        name: null,
        min: null,
        emailMatch: null,
      },
    };
  },
  created() {
    this.rules.name = (v) => v.length >= 3 || this.$t("rules.name");
    this.rules.confirmPasswordRules = (value) =>
      value === this.userMe.password || this.$t("rules.confirmPassword");
    this.rules.min = (v) => v.length >= 6 || this.$t("rules.min_password");
    this.rules.required = (v) => !!v || this.$t("rules.require");
    this.rules.emailMatch = (v) =>
      !v ||
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        v
      ) ||
      this.$t("rules.emailMatch");
  },

  components: { languages },

  computed: {
    userMe() {
      return this.$store.getters["users/userMe"];
    },

    ...mapState(["cities"]),

    ...mapGetters("employees", ["employees"]),
  },
  methods: {
    getCity(id) {
      let c = this.cities.find((element) => element.id == id);
      return this.$i18n.locale == "ar" ? c.ar_name : c.en_name;
    },
    avatarPicker() {
      document.getElementById("avatarPicker").click();
    },
    selectFile(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.avatar = e.target.result;
      };
      reader.readAsDataURL(file);
      this.uploadAvatar();
    },
    uploadAvatar() {
      const payload = new FormData();
      payload.append("avatar", this.newAvatar);
      this.$store.dispatch("users/uploadAvatar", payload).then((res) => {
        this.$store.dispatch("users/me");
      });
    },
    updateCompany() {
      this.$refs.form.validate();
      if (this.valid == false) return;
      this.loading = true;
      this.$store.dispatch("users/updateMe", this.userMe).then((res) => {
        this.loading = false;
        this.$store.dispatch("users/me");
      });
      // if (this.avatar != null) this.uploadAvatar();
    },
  },
};
</script>
